import { render, staticRenderFns } from "./PinnedFiltersTemplates.vue?vue&type=template&id=5487ff14&scoped=true"
import script from "./PinnedFiltersTemplates.vue?vue&type=script&lang=js"
export * from "./PinnedFiltersTemplates.vue?vue&type=script&lang=js"
import style0 from "./PinnedFiltersTemplates.vue?vue&type=style&index=0&id=5487ff14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487ff14",
  null
  
)

export default component.exports